module.exports = __webpack_public_path__ + "img/img_32419_0_8.ed577762.png";